import type { FlowStatus } from '@/app/guide/flowStatus';
import { DraftBadge, PreviewBadge, PublishedBadge, SuccessBadge, WarningBadge } from '@/components/badges/Common';
import type { FC } from 'react';

/**
 * What one guide's status reads as: first what it IS (published / in preview / just a draft), then
 * how its content compares to what's live. Shared by the editor's header and the Guides table so a
 * guide looks the same wherever you meet it.
 */
export const FlowStatusBadges: FC<{ status: FlowStatus }> = ({ status }) => (
    <div className="flex flex-row flex-wrap gap-1">
        {status.published && <PublishedBadge />}
        {!status.published && status.preview && <PreviewBadge />}
        {!status.published && !status.preview && <DraftBadge />}
        {status.published && status.inSyncWithLive && <SuccessBadge>in-sync</SuccessBadge>}
        {/* Amber, matching the status dot this same condition turns amber. */}
        {status.published && !status.inSyncWithLive && <WarningBadge>pending-changes</WarningBadge>}
        {!status.published && status.inSyncWithLive && <SuccessBadge>matches-live</SuccessBadge>}
    </div>
);
